export const DEPENDS_ON_PILL_PREFIX = '↳';

export const getDependsOnPillAriaLabel = stepKey => `Jump to step ${stepKey}`;
